<template>
	<el-radio-group v-model="option" size="mini" :disabled="disabled" @change="change" :class="[customizedStyle]">
		<el-radio v-if="!isButton" :label="item.key" v-for="item in list" :key="item.key" :style="{'display':isInvite&&item.key==3 ? 'none': ''}">
			{{item.name}}
		</el-radio>
		<el-radio-button v-if="isButton" :label="item.key" v-for="item in list" :key="item.key" :disabled="item.disabled">
			<i v-if="option==item.key&&showCheck" class="el-icon-check" style="color:#fff"></i>{{item.name}}
			<slot :item="item"></slot>
		</el-radio-button>
	</el-radio-group>
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { model } from 'service/model'
	import { getConstantByKeyword, formatDate } from 'service/utils'

	@Component({
		props: [
			'groupName',
			'result',
			'disabled',
			'isResultName',
			'resultName',
			'isButton',
			'isInvite',
			'filterV',
			'showCheck',
			'customizedStyle', //cus-style-[i]
			'showAll'
		],
		watch: {
			option : {
				handler(curVal, oldVal){
					if(this.isResultName){
						this.$emit('update:resultName', this.list.find(item => item.key === curVal).name)
					}
					this.$emit('update:result', curVal)
					this.$emit('callback', curVal)
				}
			},
			result : {
				handler(curVal, oldVal){
					this.option = curVal
				}
			}
		}
	})

	export default class RadioTabs extends Vue {

		list = []
		option = ''
		mounted(){
			let Arr = []
			let constantNames = [
			'SEX', //性别
			'CUSTOMER_TYPE', //客户类型
			'CLIENT_TYPE', //客户端类型
			'VISIT_TYPE', //到访类型
			'CLASS_TYPE', //班级类型
			'SCHEDULE_TYPE', //档期
			'REFUND_TYPE', // 退费性质
			'COMMUNITY_TYPE', // 群类型
			'EDIT_ITS_TYPE',
			'CUSTOMER_STATUS'
			]
			switch(this.groupName){
				case 'FEEDBACKTYPE'://反馈类型
					Arr = [{name:'建议', key:1001}, {name:'需求', key:1002}, {name:'问题', key:1003}]
					break;
				case 'FUNCTIONSTATUS'://功能类型
					Arr = [{name:'功能', key:2}, {name:'特殊关联', key:3}, {name:'搜索条件', key:4}]
					break;
				case 'APPROVEMESS'://审批详情
					Arr = [{name:'同意', key:1}, {name:'拒绝', key:-1}]
					break;
				case 'STUDENTTYPE'://
					Arr = [{name:'全部', key:1,disabled:false}, {name:'结课', key:0,disabled:false}, {name:'低课时', key:3,disabled:true},
					{name:'近停课', key:4,disabled:true}, {name:'近结课', key:5,disabled:true}]
					break;
				case 'STUDYTYPE'://
					Arr = [{name:'精雕细课', key:1}, {name:'学科导图', key:2}, {name:'错题本', key:3}, {name:'学习报告', key:4}, {name:'课程信息', key:5}]
					break;
				case 'curentPay': // 新的缴费方式
					this.getBranchPayMethod()
					break;
				case 'yesORNo':
					Arr = [{name:'是', key:'1'}, {name:'否', key:'0'}]
					break;
				case 'OPT_TYPE':
					Arr = [{name:'新增EID', key:'1'}, {name:'作废编号', key:'2'}]
					break;
				case 'ADMIN_BASE':
					Arr = [{name:'学生信息', key:'1'}, {name:'新增EID', key:'2'}]
					break;
				case 'menu_type':
					Arr = [{name:'BOSS菜单', key:'1'}, {name:'外链菜单', key:'2'}]
					break;
				case 'customer_stage':
					Arr = [
						{name:'全部', key:'1'},
						{name:'未分配', key:'2'},
						{name:'新客户', key:'3'},
						{name:'活跃客户', key:'4'},
						{name:'沉默客户', key:'5'},
						{name:'流失客户', key:'6'},
						{name:'已签约', key:'7'},
						{name:'无效', key:'8'},
					]
					break;
				case 'customer_rank':
					if(this.showAll){
						Arr = [{name: '全部', key: '0'}].concat([
							{name:'重要', key:'1'},
							{name:'紧急', key:'2'},
							{name:'一般', key:'3'},
						])
					}else{
						Arr = [
							{name:'重要', key:'1'},
							{name:'紧急', key:'2'},
							{name:'一般', key:'3'},
						]
					}
					break;
				case 'recent_day':
					let dayArr = [0,1,3,15]
					Arr = dayArr.map(iday =>{
						if(iday===0){
							return {
								name:'全部', key:'0'
							}
						}
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * iday);
						return {
							name: iday + '天',
							key: formatDate(date,'yyyy-MM-dd') + '_' + formatDate(new Date(),'yyyy-MM-dd')
						}
					})
					/* Arr = [
						{name:'1天', key:'1'},
						{name:'3天', key:'2'},
						{name:'15天', key:'3'},
						{name:'自定义', key:'4'},
					] */
					break;
				default:
					if(constantNames.indexOf(this.groupName) > -1){
						if(this.showAll){
							Arr = [{name: '全部', key: 0}].concat(this.getGroupData())
						}else{
							Arr = this.getGroupData()
						}

					}else{
						console.log('未定义的'+this.groupName)
					}
			}
			this.list = Arr.length ? Arr : this.list
			if(this.result){
				this.option = this.result
				return false
			}
			if(!Arr.length) return false
			this.option = Arr[0].key
		}

		getGroupData(){
			if(this.filterV){
				return getConstantByKeyword(this.groupName).filter(item =>{
					return item.item_value!=this.filterV
				}).map(item =>{
					return {
						key: item.item_value,
						name: item.item_name,
						disabled: item.status
					}
				})
			}
			return getConstantByKeyword(this.groupName).map(item => {
				return {
					name : item.item_name,
					key : item.item_value
				}
			})
		}

		getBranchPayMethod(){ //获取分公司支付方式
			this.fetch(model.getBranchPayMethod).then( res =>{
				this.list = res.map(item => {
					return {
						name : item.pay_name,
						key : item.id
					}
				})
				if(this.result){
					this.option = this.result
					return false
				}
				this.option = this.list[0].key
			}, data =>{
				this.list =  []
			})
		}
		change(val){
			this.$emit('change',val)
		}
	}

</script>
<style lang="scss" scoped>
.cus-style-1{
	/deep/ .el-radio-button .el-radio-button__inner{
		background-color: #f3f3f3;
		color:#585A60;
		border-radius: 2px;
		border-color: #f3f3f3;
		&:hover{
			color: #457FF3
		}
	}
	/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
		color: #FFF;
		background-color: #457FF3;
		border-color: #457FF3;
		box-shadow: -1px 0 0 0 #457FF3;
	}
	/deep/ .el-radio-button + .el-radio-button{
		margin-left: 4px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/RadioTabs.vue